import { object } from 'zod';

import { ProductCountingRoundStrategySchema, ProductGroupsSchema } from '@occc/validation';

export const BaseEarnSchema = object({
  roundMoneyAmount: ProductCountingRoundStrategySchema,
  ineligibleProductGroups: ProductGroupsSchema,
});
